import { render } from "./account-manager.vue?vue&type=template&id=d96ce6d6&scoped=true&ts=true"
import script from "./account-manager.vue?vue&type=script&lang=ts"
export * from "./account-manager.vue?vue&type=script&lang=ts"

import "./account-manager.vue?vue&type=style&index=0&id=d96ce6d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96ce6d6"]])

export default __exports__